import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { DomSanitizerContext, SafeValue } from './dom-sanitizer.helper';

@Pipe({
  name: 'domSanitizer',
  standalone: true,
})
export class DomSanitizerPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(
    content: string,
    context: SecurityContext | string | DomSanitizerContext = DomSanitizerContext.HTML
  ): SafeValue {
    if (!content) {
      return '';
    }

    const securityContext = this.getSecurityContext(context);

    try {
      const sanitizedContent = this.domSanitizer.sanitize(securityContext, content);

      return sanitizedContent || '';
    } catch (error) {
      return '';
    }
  }

  private getSecurityContext(context: SecurityContext | string): SecurityContext {
    if (typeof context === 'number') {
      return context;
    }

    switch (context.toLowerCase()) {
      case 'html':
        return SecurityContext.HTML;
      case 'style':
        return SecurityContext.STYLE;
      case 'script':
        return SecurityContext.SCRIPT;
      case 'url':
        return SecurityContext.URL;
      case 'resource_url':
      case 'resourceurl':
        return SecurityContext.RESOURCE_URL;
      default:
        return SecurityContext.HTML;
    }
  }
}
